import React from 'react'
import { Navigate } from 'react-router-dom';
import { LOGIN } from '../../constants/appNavigations';
import userServices from '../../services/userServices'

export default function ProtectedRoute({children}){
  const user = userServices.getUser();
  return user ? children : <Navigate to={LOGIN} replace/>
}
